export const ACORIS_PRICER_REGIME = {
  RG: "SECURITE_SOCIALE",
  RL: "ALSACE_MOSELLE",
  RA: "REGIME_SALARIES_AGRICOLES",
  MSA_RL: "MSA_RL",
};

const MSA_RL_ALIASES = [
  "MSA_RL",
  "MSA-RL",
  "MSA_ALSACE_MOSELLE",
  "MSA-ALSACE-MOSELLE",
];

export const normalizeAcorisImportRegime = (raw) => {
  const key = String(raw || "")
    .trim()
    .toUpperCase();
  if (MSA_RL_ALIASES.includes(key)) {
    return ACORIS_PRICER_REGIME.MSA_RL;
  }
  return key;
};

export const isAcorisAlsaceLocalRegime = (socialRegime) => {
  const normalized = normalizeAcorisImportRegime(socialRegime);
  return (
    normalized === ACORIS_PRICER_REGIME.RL ||
    normalized === ACORIS_PRICER_REGIME.MSA_RL
  );
};
